import React from 'react';
import { ArrowUpRight, ExternalLink, Check } from 'lucide-react';
import Reveal from './Reveal';

const WORKS = [
  {
    id: 'padelelvo',
    name: 'Padel Elvo',
    sub: 'Padel & Pickleball',
    description:
      "Sito web per il club di padel e pickleball di Biella. Booking integrato, presentazione campi, calendario eventi e contatti rapidi. Brand pulito in bianco e nero con grafica delle montagne biellesi.",
    image:
      'https://customer-assets.emergentagent.com/job_solar-minimal-clean/artifacts/cwl24tn8_IMG_6817.jpeg',
    url: 'https://padelelvo.it/#home',
    tags: ['Sito Vetrina', 'Brand & Logo', 'Mobile First'],
    color: '#0f1620',
  },
];

export default function Works() {
  return (
    <section id="lavori" className="relative py-24 md:py-32 bg-[#f6f4ee]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal variant="fade">
          <div className="flex items-start gap-3 mb-10">
            <span className="text-[#1e6cb0] font-bold text-[14px] tracking-[0.18em]">02</span>
            <span className="w-10 h-px mt-3 bg-[#1e6cb0]/60" />
            <span className="text-[12px] tracking-[0.2em] uppercase font-semibold text-neutral-500">
              Lavori realizzati
            </span>
          </div>
        </Reveal>

        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <Reveal as="h2" variant="up" delay={80} className="lg:col-span-7 heading-mega text-[42px] sm:text-[56px] md:text-[72px] text-neutral-900">
            I nostri lavori<br />
            <span className="text-[#1e6cb0]">appena fatti.</span>
          </Reveal>
          <Reveal as="p" variant="up" delay={220} className="lg:col-span-5 text-[16px] leading-relaxed text-neutral-600 lg:mt-6">
            Niente mockup, niente render. Solo siti reali che stiamo gi&agrave; mandando online.
            Cliccaci sopra, naviga, prova: sono live in questo momento.
          </Reveal>
        </div>

        <div className="space-y-10">
          {WORKS.map((w, i) => (
            <Reveal key={w.id} variant="up" delay={i * 120} duration={850}>
            <article
              className="group grid lg:grid-cols-12 gap-8 lg:gap-12 items-center bg-white rounded-3xl border border-black/5 p-6 md:p-10 shadow-[0_20px_60px_-25px_rgba(0,0,0,0.12)] card-hover overflow-hidden"
            >
              {/* Image */}
              <div className={`lg:col-span-7 ${i % 2 === 1 ? 'lg:order-2' : ''}`}>
                <a
                  href={w.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block relative rounded-2xl overflow-hidden bg-neutral-50 aspect-[4/3] sm:aspect-[16/10]"
                >
                  <img
                    src={w.image}
                    alt={w.name}
                    className="absolute inset-0 w-full h-full object-contain p-4 sm:p-6 transition-transform duration-700 group-hover:scale-[1.03]"
                  />
                  {/* Hover overlay */}
                  <div className="absolute inset-0 bg-[#1e6cb0]/0 group-hover:bg-[#1e6cb0]/10 transition-colors duration-500" />
                  <div className="absolute top-4 right-4 inline-flex items-center gap-1.5 bg-white/90 backdrop-blur-sm border border-black/5 px-3 py-1.5 rounded-full text-[11px] font-bold tracking-[0.18em] uppercase text-[#1e6cb0] shadow-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <ExternalLink className="w-3 h-3" />
                    Apri il sito
                  </div>
                </a>
              </div>

              {/* Details */}
              <div className={`lg:col-span-5 ${i % 2 === 1 ? 'lg:order-1' : ''}`}>
                <div className="flex items-center gap-2 mb-3">
                  <span className="w-2 h-2 rounded-full bg-[#22c55e] animate-pulse" />
                  <span className="text-[11px] tracking-[0.2em] uppercase font-bold text-[#22c55e]">
                    Online ora
                  </span>
                </div>

                <div className="text-[12px] tracking-[0.18em] uppercase font-semibold text-neutral-500 mb-2">
                  {w.sub}
                </div>
                <h3 className="font-display text-[34px] md:text-[44px] font-extrabold text-neutral-900 leading-tight mb-4">
                  {w.name}
                </h3>
                <p className="text-[15.5px] leading-relaxed text-neutral-600 mb-6">
                  {w.description}
                </p>

                <ul className="flex flex-wrap gap-2 mb-7">
                  {w.tags.map((t) => (
                    <li
                      key={t}
                      className="inline-flex items-center gap-1.5 text-[12px] font-semibold text-neutral-700 bg-neutral-100 border border-black/5 px-3 py-1.5 rounded-full"
                    >
                      <Check className="w-3 h-3 text-[#1e6cb0]" strokeWidth={3} />
                      {t}
                    </li>
                  ))}
                </ul>

                <div className="flex flex-wrap items-center gap-3">
                  <a
                    href={w.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 bg-[#1e6cb0] text-white px-6 py-3.5 rounded-full font-semibold text-[15px] btn-glow"
                  >
                    Visita il sito <ArrowUpRight className="w-4 h-4" />
                  </a>
                  <span className="text-[13px] text-neutral-500 font-mono">
                    {w.url.replace(/^https?:\/\//, '').replace(/#.*$/, '')}
                  </span>
                </div>
              </div>
            </article>
            </Reveal>
          ))}
        </div>

        <div className="mt-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 p-8 md:p-10 rounded-3xl bg-white border border-black/5">
          <div>
            <div className="text-[12px] tracking-[0.2em] uppercase font-semibold text-[#1e6cb0] mb-3">
              Il prossimo lavoro?
            </div>
            <h3 className="heading-mega text-[26px] md:text-[34px] text-neutral-900 max-w-xl">
              Pu&ograve; essere il tuo. Scrivimi e ne parliamo.
            </h3>
          </div>
          <a
            href="https://wa.me/393383463712?text=Ciao!%20Ho%20visto%20i%20vostri%20lavori%20e%20vorrei%20parlare%20di%20un%20sito%20per%20la%20mia%20attivit%C3%A0."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#1e6cb0] text-white px-7 py-4 rounded-full font-semibold btn-glow whitespace-nowrap"
          >
            Scrivimi su WhatsApp <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
